import { createSlice } from '@reduxjs/toolkit';

import { getElhaghiyehHayeSadereh, printElhaghiyehAtashsoozi } from '../Action/action';

import ElhaghiyehHayeSaderehInitialState from './ElhaghiyehHayeSaderehInitialState';
import ActiveOrdersInitialState from './ElhaghiyehHayeSaderehInitialState';

export const elhaghiyehHayeSaderehSlice = createSlice({
  name: 'atashsoozi/elhaghiyehHayeSadereh',
  initialState: ActiveOrdersInitialState,
  reducers: {
    clearElhaghiyehHayeSadereh: (state) => {
      state.elhaghiyehHayeSadereh = ElhaghiyehHayeSaderehInitialState.elhaghiyehHayeSadereh;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getElhaghiyehHayeSadereh.pending, (state) => {
        state.elhaghiyehHayeSadereh.loading = true;
      })
      .addCase(getElhaghiyehHayeSadereh.fulfilled, (state, action) => {
        state.elhaghiyehHayeSadereh.loading = false;
        state.elhaghiyehHayeSadereh.data = action.payload;
      })
      .addCase(getElhaghiyehHayeSadereh.rejected, (state) => {
        state.elhaghiyehHayeSadereh.loading = false;
      });
    builder
      .addCase(printElhaghiyehAtashsoozi.pending, (state) => {
        state.print.loading = true;
      })
      .addCase(printElhaghiyehAtashsoozi.fulfilled, (state) => {
        state.print.loading = false;
      })
      .addCase(printElhaghiyehAtashsoozi.rejected, (state) => {
        state.print.loading = false;
      });
  },
});

export const { clearElhaghiyehHayeSadereh } = elhaghiyehHayeSaderehSlice.actions;

export default elhaghiyehHayeSaderehSlice.reducer;
